import React from 'react'
import { useState, useEffect } from 'react';
import Loading from '../../../TOURISME/COMPONENTS/Loading/Loading'
import Header from '../../COMPONNENT/Header/Header';
import backimage from '../../../ASSETS/AfImmigration/imgDestination.png'
import {Link} from 'react-router-dom'
import logo1 from '../../../ASSETS/tourisme/Image/LOGO.png'
import BoutonLogin from '../../../TOURISME/COMPONENTS/BoutonLogin/BtnLogin'
import Footer from '../../COMPONNENT/Footer/Footer';
import CI from '../../../ASSETS/AfImmigration/participation-sitho2.png'
import drapeauCI from '../../../ASSETS/AfImmigration/drapeau-cote-ivoire.png'
import { IoPin } from "react-icons/io5";
import { IoIosSend } from "react-icons/io";
import Country from '../../../API/country';
import { useTranslation } from 'react-i18next';


function VoirPlus() {

    const [loading, setLoading] = useState(true);

    interface countryById {
        id:number,
        Icon: string,
        code:string,
        indicator:number,
        Name:string,
        fr_Name:string,
        code_language:string,
        currency:number,
        Commentaire:string
    }

    const [country,setCountry] = useState<countryById | null>(null)
    
    let searchParam = new URLSearchParams(window.location.search);
    let idCountry = searchParam.get('q');

    const getCountry =  ()=>{
         Country.getCountryById(idCountry).then((res:any)=>{
                setCountry(res.data.data)
         }) 
         .catch((err:any)=>{
            console.log(err)
         })      
    }
 
    useEffect(() => {
       
        getCountry();

        const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes

        // Nettoyer le timer si le composant est démonté avant la fin du délai
        return () => clearTimeout(timer);
    }, []);

    const {t} = useTranslation() as {t:(key:string)=>string}

  return (
    <div className='bg-[#F7F7F7]'>
          {loading ? (
              // Afficher le spinner tant que loading est true
              <Loading/>
          ) : (
        <>
        <Header/>
        <div style={{ backgroundImage:`url(${backimage})` }} className='h-screen w-screen bg-cover bg-center bg-no-repeat'>
            <div className='flex s:flex-col sm:flex-row sm:justify-between'>
                <Link to='/accueil_afrique_immigration'>
                    <div style={{ borderBottomRightRadius: "100px" }} className=' sm:pl-5 s:pl-2 bg-white w-40 pb-4  pr-4   '>
                        <img src={logo1} className='h-20  s:pl-0 pt-6 ' alt='logo' />
                    </div>
                </Link>
                {/* <BoutonLogin/> */}
            </div>
          <div className='relative top-[200px] xs:left-20 s:left-6'>
            <div className=' xs:text-6xl uppercase  s:text-xl sm:text-4xl font-semibold text-white xs:w-[600px]'>
               {t("Destination")}
            </div>
            <div className='h-2 w-20 bg-[#FCCA46] mt-4'></div>
          </div>

        </div>

        <div className='py-14 flex flex-col space-y-4 items-center'>
            <div className='flex flex-row items-center space-x-2 '>
                <IoPin className='text-2xl text-[#fe7f2d]' />
                <div className='text-2xl font-semibold text-[#233D4D]'>{t("Votre destination")}</div>
            </div>
            <div className='text-lg xs:w-[700px] text-center px-2'>
               {country?.Name} est située dans le sud-ouest de l’océan Pacifique et se compose principalement
                de deux grandes îles : l’île du Nord et l’île du Sud. Le pays est célèbre pour ses paysages
                 spectaculaires : montagnes alpines, volcans actifs, plages sauvages, forêts denses et lacs cristallins. 
            </div>
            <div className='pt-10 place-content-center place-items-center grid md:grid-cols-4 gap-4 s:grid-cols-1 xs:grid-cols-2'>
               
            </div>
        </div>

        <div className='pb-14 grid s:grid-cols-1 md:grid-cols-2 s:px-4 xs:px-14 s:gap-10 xs:gap-20'>
            <img src={CI} alt="Ci" className="w-[600px]" />
            {/* <img src={`data:image/png;base64,${country?.Icon}`} alt="Ci" className="w-[600px]" /> */}
            <div className='flex flex-col space-y-3'>
                <div className='flex items-center space-x-3'>
                    <img src={`data:image/png;base64,${country?.Icon}`} alt='drapeau' className='w-5'/>
                    <div className='font-semibold text-xl'>{country?.Name} </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-semibold text-xl'>Capitale : </div>
                    <div className='text-xl font-light'> Yamoussokro</div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-semibold text-xl'>Superficie : </div>
                    <div className='text-xl font-light'> 432 000 m<sup>2</sup></div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-semibold text-xl'>Président : </div>
                    <div className='text-xl font-light'> Outarra Alassane</div>
                </div>
                {/* <Link to='/PrendreRendezVous '>
                    <button className='s:mt-8 sm:mt-12 bg-[#FCCA46] text-base flex flex-row items-center space-x-2 text-white h-10 w-[200px]  px-2 transform active:scale-75 transition-transform'>
                        <p>Prendre rendez-vous</p>
                        <IoIosSend />
                    </button>
               </Link> */}

                {/* <Link to='/appointement/RendezVousService'>
                        <button className='s:mt-8 sm:mt-12 bg-[#FCCA46] text-base flex flex-row items-center space-x-2 text-white h-10 w-[200px]  px-2 transform active:scale-75 transition-transform'>
                            <p>{t("Prendre rendez-vous")}</p>
                            <IoIosSend />
                        </button>
                </Link> */}
            </div>
        </div>
        <div className='pb-6 text-lg s:px-2 xs:px-14'>
           {country?.Name} est située dans le sud-ouest de l’océan Pacifique et se compose principalement de deux grandes îles : l’île du Nord et l’île du Sud. Le pays est célèbre pour ses paysages spectaculaires : montagnes alpines, volcans actifs, plages sauvages, forêts denses et lacs cristallins.
           Le climat varie du subtropical au nord au tempéré frais au sud, avec des saisons inversées par rapport à l'hémisphère nord (été de décembre à février, hiver de juin à août). 
        </div>
        
       
        <Footer/>
        </>
          )}
    </div>
  )
}

export default VoirPlus